<template>
  <div class="jRules">
    <div class="wrap">

      <div class="bullet-center fl-right">
        <router-link
          to="/flows">
          <i class="fa fa-times"/>
        </router-link>
      </div>

      <div class="bullet-center">
        <h2>Update Rules</h2>
        <br>
      </div>

      <div>
        <h4
          v-if="!flow[0]"
          class="select-rules">
          Select some flow to update rules
        </h4>
      </div>


      <b-row>
        <b-col/>
        <b-col cols="10">
          <jRulesTableNew
            ref="tableRules"
            @rowClick="rowClick"/>
        </b-col>
        <b-col/>
      </b-row>

      <div
        v-if="flow[0]"
        class="selected-bottom-rules">
        <b-row>
          <b-col/>
          <b-col cols="10">

            <!-- title -->
            <h2>{{ rules_detail.name }}</h2>

            <!-- Selected flow for rules -->
            <div class="overflow-scroll">
              <div class="inline--block">
                <div class="flow-new__bullet-top">
                  <i class="fa fa-square"/>
                </div>
              </div>
              <div
                v-for="(anu, index) in flow"
                :key="index"
                class="inline--block">
                <div
                  v-if="index === 0"
                  class="line-horizontal"/>
                <div
                  v-if="index > 0"
                  class="line-horizontal next-line"/>
                <div class="inline--block">
                  <div class="flow-table flow-arrow light-blue-flow">
                    {{ anu.name }}
                  </div>
                </div>
              </div>
            </div>

            <!-- button create or clear -->
            <div class="wrap-button-flow">
              <b-button
                class="btn blue"
                @click="$refs.saveRules.show()">
                UPDATE
              </b-button>
              <b-button
                class="btn blue outline"
                @click="clearRules">
                CLEAR
              </b-button>
            </div>

          </b-col>
          <b-col/>
        </b-row>
      </div>
    </div>

    <b-modal
      ref="saveRules"
      class="mod-form save-flow-approver"
      centered>

      <!-- close button modal -->
      <div
        class="close-modal-rules"
        @click="$refs.saveRules.hide()">
        <i class="fa fa-times"/>
      </div>

      <!-- title modal -->
      <div class="title-rules">
        <i class="fa fa-square"/>
        Update Rules
      </div>

      <b-form-group :class="{'error-input' : $v.rule_name.$error}">
        <label>Rules Name*</label>
        <j-input
          v-model="rule_name"
          :max-length="255"
          placeholder="ex: Carry"/>
      </b-form-group>

      <div class="wrap-button-rules">
        <b-button
          class="btn blue"
          @click="saveRules">
          UPDATE
        </b-button>
      </div>
    </b-modal>

    <div class="space-more"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import jRulesTableNew from './jRulesTableNew';

export default {
  components: { jRulesTableNew },
  data() {
    return {
      flow: [],
      rule_name: '',
    };
  },
  validations: {
    rule_name: { required },
  },
  computed: {
    ...mapState('jStoreRules', ['rules_detail']),
    list_flows() {
      return this.flow.map((data, index) => ({
        id: data.id,
        order: index + 1,
      }));
    },
    save_rules() {
      return {
        id: this.$route.params.id,
        name: this.rule_name,
        description: '',
        flows: this.list_flows,
      };
    },
  },
  watch: {
    flow(newData) {
      if (newData === '') {
        this.$refs.tableRules.clearRules();
      }
    },
    rules_detail(newData) {
      this.flow = newData.flows;
      this.rule_name = newData.name;
    },
  },
  created() {
    const getID = {
      id: this.$route.params.id,
    };
    this.getDetailRules(getID);
  },
  methods: {
    ...mapActions('jStoreRules', ['createNewRules', 'getDetailRules', 'updateRule']),
    rowClick(data) {
      this.flow = data;
    },
    saveRules() {
      this.$v.rule_name.$touch();
      if (!this.$v.rule_name.$error) {
        this.updateRule(this.save_rules);
      }
    },
    clearRules() {
      this.flow = '';
    },
  },
};
</script>

<style lang="scss">
.select-rules {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/flow-rule/rules/jRulesUpdate.vue